var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-message",
    transform: "translate(-0.44 -13.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M19.44,19.111v8.533A2.134,2.134,0,0,1,17.645,30H5.235a2.134,2.134,0,0,1-1.8-2.353v-12a1.912,1.912,0,0,1,.414-1.222.6.6,0,0,1,.984.026l4.843,6.216a2.123,2.123,0,0,0,3.517,0l3.729-4.785H7.384S5.948,14,5.948,14H18.183a1.108,1.108,0,0,1,.844.426,1.088,1.088,0,0,1,.236.679,1.108,1.108,0,0,1-.215.691L14.2,22.009a3.337,3.337,0,0,1-5.527,0l-3.8-4.878V27.643a.427.427,0,0,0,.359.471H17.645A.427.427,0,0,0,18,27.643V19.111l1.436-1.881S19.439,19.111,19.44,19.111Z",
    transform: "translate(-3)",
    fill: "#0071b9"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMessage);
export default __webpack_public_path__ + "static/media/ico-message.f0764e7d.svg";
export { ForwardRef as ReactComponent };